import React, { useState, useContext, useEffect, useRef, useCallback } from 'react'
import openSocket from 'socket.io-client'
import FilterPanel from '@/custom/components/organisms/FilterPanel'
import GridView from '@/custom/components/molecules/ProductCard/GridView'
import './Search.css'
import CustomSelect from '@/product/components/atoms/Inputs/CustomSelect'
import { Button, Fade } from '@material-ui/core'
import InfiniteScroll from 'react-infinite-scroll-component'

import ListView from '@/custom/components/molecules/ProductCard/ListView'
import Drawer from '@material-ui/core/Drawer'
import ProductView from '@/custom/components/organisms/ProductView'
import ProductContext from '@/product/context/product/productContext'
import AuthContext from '@/product/context/auth/authContext'
import AlertContext from '@/product/context/alert/alertContext'
import CommonContext from '@/product/context/common/commonContext'
import { Pagination } from '@material-ui/lab'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import { messageHandler } from '@/product/common/socketHandler'
import { useCustomMediaQuery } from '@/product/common/components'
import NoRecordsFound from '@/custom/components/atoms/NoRecordsFound'
import Loaders from '@/custom/components/molecules/Loaders'
import { useFormik } from 'formik'
import { useMediaQuery } from '@material-ui/core'
import customCommonContext from '@/custom/context/common/commonContext'
import { isPointWithinRadius } from 'geolib'

import SEO from '@/utils/SEO'
import { cloneDeep, debounce, isEqual } from 'lodash'
import Popup from '@/custom/components/organisms/Popup'
const useStyles = makeStyles({
    fullList: {
        width: 'auto',
    },
})

const SearchComp = (props) => {
    const productContext = useContext(ProductContext)

    const alertContext = useContext(AlertContext)
    const authContext = useContext(AuthContext)

    const commonContext = useContext(CommonContext)
    const CustomCommonContext = useContext(customCommonContext)
    const { getGlobalVariable, alldata_all_dropdown, allLocations } = CustomCommonContext
    const { setSearchValue, searchValue, clearSearchValue } = commonContext
    const { user, isAuthenticated, saveSearch, responseStatus: responseStatusAuth } = authContext

    const observer = useRef()

    const [newScrollInitial, setNewScrollInitial] = useState(true)

    const [feature, setFeature] = useState({})
    // const [isLoading, setIsLoading] = useState(true)

    const [allProducts, setAllProducts] = useState()

    const { search_allproducts, getAllSearchProducts, responseStatus, addSavedSearch } =
        productContext

    const { setAlert } = alertContext

    const auctionView = props.auctionView
    const [state, setState] = useState({
        right: false,
        bottom: false,
        data: {},
    })
    const formikSearch = props.formikSearch
    const [viewProduct, setViewProduct] = useState([])
    const [favoriteRerender, setFavoriteRerender] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    // INFINITE SCROLL - Commented out for pagination
    // const [hasMore, setHasMore] = useState(true)
    // const [isInfiniteScroll, setIsInfiniteScroll] = useState(false)

    const isMacroMobile = useMediaQuery('(max-width:550px) and (min-width:430px)')
    const isNanoMobile = useMediaQuery('(max-width:430px)')

    const onHandlePage = (event, value) => {
        // Update local state immediately for UI feedback
        setCurrentPage(value)

        // Show loading immediately
        props.setIsProductLoading(true)

        // formikSearch.values.page = value
        formikSearch.setFieldValue('page', value)
        console.log(formikSearch?.values, 'pagination data')
        formikSearch.handleSubmit()
        // getAllSearchProducts(
        //     { ...formikSearch.values, page: value },
        //     props?.from ? props?.from : 'liveProducts',
        //     'custom/',
        // )
        const currentSalesSection = document.querySelector('.current-sales-section')
        if (currentSalesSection) {
            const yOffset = -20
            const y = currentSalesSection.getBoundingClientRect().top + window.pageYOffset + yOffset
            window.scrollTo({ top: y, behavior: 'auto' })
        }
    }

    // useEffect(() => {
    //     setCurrentPage(formikSearch.values.page)
    // }, [formikSearch.values.page])

    const isLoading = props?.isProductLoading

    // INFINITE SCROLL - Commented out for pagination
    // useEffect(() => {
    //     if (responseStatusAuth && responseStatusAuth?.message === 'Logged in successfully') {
    //         setCurrentPage(1)
    //         formikSearch.values.page = 1
    //         formikSearch.handleSubmit()
    //     }
    // }, [responseStatusAuth && responseStatusAuth?.message === 'Logged in successfully'])

    useEffect(() => {
        if (props.initialLoad) {
            props.setInitialLoad(false)
        }

        // Reset to page 1 on initial load or filter change
        setCurrentPage(1)
        formikSearch.values.page = 1
        formikSearch.handleSubmit()
    }, [props.initialLoad])

    // INFINITE SCROLL - Commented out for pagination
    // const fetchMoreData = () => {
    //     const totalRecords = allProducts?.totalRecords || 0
    //     const itemsPerPage = formikSearch.values.limit || 15
    //     const currentItems = viewProductRef.current.length
    //     // const currentPage = formikSearch.values.page || 1

    //     if (itemsPerPage * currentPage >= totalRecords) {
    //         formikSearch.setFieldValue(`infinite`, false)
    //         setIsInfiniteScroll(false)
    //         setCurrentPage(1)
    //         setHasMore(false)
    //     } else if (itemsPerPage * currentPage < totalRecords) {
    //         formikSearch.setFieldValue(`infinite`, true)
    //         setIsInfiniteScroll(true)
    //         setCurrentPage(currentPage + 1)
    //         const newValues = { ...formikSearch.values, page: currentPage + 1 }
    //         // formikSearch.values.page = currentPage + 1
    //         // formikSearch.handleSubmit()
    //         getAllSearchProducts(newValues, props?.from ? props?.from : 'liveProducts', 'custom/')
    //     } else {
    //         setHasMore(true)
    //         setCurrentPage(1)
    //         setIsInfiniteScroll(false)
    //         formikSearch.setFieldValue(`infinite`, false)
    //     }
    // }

    useEffect(() => {
        if (search_allproducts.from === props.from) {
            if (search_allproducts.records.length) {
                setViewProduct(search_allproducts.records)
                setAllProducts(search_allproducts)

                if (!newScrollInitial) {
                    const currentSalesSection = document.querySelector('.current-sales-section')
                    if (currentSalesSection) {
                        const yOffset = -20
                        const y =
                            currentSalesSection.getBoundingClientRect().top +
                            window.pageYOffset +
                            yOffset
                        window.scrollTo({ top: y, behavior: 'auto' })
                    }
                }
                {
                    props.isHome ? null : setNewScrollInitial(false)
                }
            } else {
                setViewProduct([])
                setAllProducts(search_allproducts)
            }
        }
    }, [search_allproducts, props.from])

    const viewProductRef = useRef(viewProduct)
    const userRef = useRef(user)

    // Sets product and user refrences on page load
    useEffect(() => {
        viewProductRef.current = viewProduct
        userRef.current = user
    })

    const handler = (message, type) => {
        messageHandler(
            message,
            viewProductRef.current,
            userRef.current,
            setAlert,
            setViewProduct,
            type,
            null,
            global?.successBidMessage,
        )
    }

    useEffect(() => {
        if (responseStatus) {
            if (
                responseStatus.from === 'addWatchlist' ||
                responseStatus.from === 'removeWatchlist'
            ) {
                handler(
                    {
                        id: responseStatus.data.project_id,
                        status: responseStatus.data.status,
                    },
                    'watchlistAdded',
                )
            }
        }
    }, [responseStatus])
    // Used to display items in wishlist on page load
    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'watchlist') {
                handler(
                    {
                        id: responseStatus.data.project_id,
                        status: responseStatus.data.status,
                    },
                    'watchlistAdded',
                )
            }
        }
    }, [responseStatus])

    useEffect(() => {
        const socket = openSocket(`${process.env.REACT_APP_DOMAIN}/`, { transports: ['websocket'] })
        socket.on('realclosedupdates', (data) => {
            data['date_closed'] = new Date().toISOString()
            data['bpop_belowFiveIncrement'] = new Date().toISOString()
            handler(data, 'realclosedupdates')
        })
        socket.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })

        socket.on('cartupdate', (data) => {
            handler(data, 'cartupdate')
        })

        socket.on('connect', function () {
            console.log('socket connect api hit 1')

            formikSearch.handleSubmit()
        })

        socket.on('cancelBidEmitted', (data) => {
            if (
                data?.project_id &&
                viewProductRef.current?.some((product) => product?.id === data?.project_id)
            ) {
                formikSearch.handleSubmit()
            }
        })

        return () => {
            socket.off('realclosedupdates', (data) => {
                data['date_closed'] = new Date().toISOString()
                data['bpop_belowFiveIncrement'] = new Date().toISOString()
                handler(data, 'realclosedupdates')
            })
            socket.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })

            socket.off('cancelBidEmitted', (data) => {
                if (
                    data?.project_id &&
                    viewProductRef.current?.some((product) => product?.id === data?.project_id)
                ) {
                    formikSearch.handleSubmit()
                }
            })

            socket.off('cartupdate', (data) => {
                handler(data, 'cartupdate')
            })
            socket.disconnect()
        }
    }, [])

    useEffect(() => {
        if (state.right) {
            const index = viewProduct.findIndex((s) => s.id == parseInt(state.data.id, 10))
            if (index !== -1) {
                setState({ ...state, data: viewProduct[index] })
            }
        }
    }, [viewProduct])

    const toggleDrawer = (anchor, open, data) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }
        if (open) {
            setState({ ...state, [anchor]: open, data: data })
        } else {
            setState({ ...state, [anchor]: open, data: {} })
        }
    }

    const [viewModel, setViewModal] = useState(false)
    const [selectedProduct, setSelectedProduct] = useState(null)
    const [scrollYy, setScrollY] = useState(0)
    const handlePvModal = (product) => {
        setFavoriteRerender((prev) => !prev)

        const scrollY = window.scrollY
        document.body.style.position = 'fixed'
        document.body.style.top = `-${scrollY}px`
        document.body.style.left = '0'
        document.body.style.right = '0'
        document.body.style.width = '100%'

        setScrollY(scrollY)

        setSelectedProduct(product) // Store full product object

        setViewModal(true) // Open modal
    }

    const handleClose = useCallback(() => {
        document.body.style.position = ''
        document.body.style.top = ''
        document.body.style.left = ''
        document.body.style.right = ''
        document.body.style.width = ''
        window.scrollTo(0, scrollYy)

        setFavoriteRerender((prev) => !prev)

        setViewModal(false)
    }, [scrollYy])

    const handleRedirect = useCallback(() => {
        document.body.style.position = ''
        document.body.style.top = ''
        document.body.style.left = ''
        document.body.style.right = ''
        document.body.style.width = ''
        window.scrollTo(0, 0)
        setScrollY(0)
    }, [])

    return (
        <>
            <div className="searchRt customContainer s">
                <div className="d-flex justify-content-between align-items-center"></div>
                {isLoading ? (
                    <Loaders name="product_grid_view" isLoading={isLoading} loop={6} />
                ) : viewProduct.length > 0 ? (
                    <>
                        <div className={`searchResults`}>
                            <Drawer
                                className="rightDrawer"
                                anchor={'right'}
                                open={state['right']}
                                onClose={toggleDrawer('right', false)}
                            >
                                <ProductView
                                    data={state.data}
                                    drawerHandler={toggleDrawer('right', false)}
                                />
                            </Drawer>

                            {/* PAGINATION - Regular product grid without infinite scroll */}
                            <div
                                style={{
                                    display: props.auctionView === 'Grid' ? 'grid' : 'block',
                                    gridTemplateColumns: isMacroMobile
                                        ? 'repeat(auto-fill, minmax(180px, 1fr))'
                                        : isNanoMobile
                                        ? 'repeat(auto-fill, minmax(145px, 1fr))'
                                        : 'repeat(auto-fill, minmax(225px, 1fr))',
                                    gap: isMacroMobile ? '10px' : isNanoMobile ? '5px' : '31px',
                                    paddingTop: '75px',
                                    paddingBottom: '25px',
                                }}
                            >
                                {viewProduct.map((data, index) => {
                                    return (
                                        <React.Fragment key={data.id || index}>
                                            {auctionView === 'Grid' ? (
                                                <GridView
                                                    data={data}
                                                    favId={`searchProd_${index}`}
                                                    drawerHandler={toggleDrawer(
                                                        'right',
                                                        true,
                                                        data,
                                                    )}
                                                    favoriteRerenderHandler={favoriteRerender}
                                                    handleProductClick={handlePvModal}
                                                />
                                            ) : (
                                                <ListView
                                                    data={data}
                                                    favId={`searchProd_${index}`}
                                                    drawerHandler={toggleDrawer(
                                                        'right',
                                                        true,
                                                        data,
                                                    )}
                                                    handleProductClick={handlePvModal}
                                                />
                                            )}
                                        </React.Fragment>
                                    )
                                })}
                            </div>

                            {/* INFINITE SCROLL - Commented out for pagination */}
                            {/* <div>
                                <InfiniteScroll
                                    dataLength={viewProduct.length}
                                    next={fetchMoreData}
                                    hasMore={hasMore}
                                    scrollThreshold={0.9}
                                    loader={
                                        <Loaders
                                            name="product_grid_view"
                                            isLoading={true}
                                            loop={1}
                                            style={{
                                                display:
                                                    props.auctionView === 'Grid' ? 'grid' : 'block',
                                                gridTemplateColumns:
                                                    'repeat(auto-fill, minmax(250px, 1fr))',
                                                gap: '1rem',
                                            }}
                                        />
                                    }
                                    style={{
                                        display: props.auctionView === 'Grid' ? 'grid' : 'block',
                                        gridTemplateColumns: isMacroMobile
                                            ? 'repeat(auto-fill, minmax(180px, 1fr))'
                                            : isNanoMobile
                                            ? 'repeat(auto-fill, minmax(145px, 1fr))'
                                            : 'repeat(auto-fill, minmax(225px, 1fr))',
                                        gap: isMacroMobile ? '10px' : isNanoMobile ? '5px' : '31px',
                                        paddingTop: '75px',
                                        paddingBottom: '25px',
                                    }}
                                >
                                    {viewProduct.map((data, index) => (
                                        <>
                                            {auctionView === 'Grid' ? (
                                                <>
                                                    <GridView
                                                        data={data}
                                                        favId={`searchProd_${index}`}
                                                        drawerHandler={toggleDrawer(
                                                            'right',
                                                            true,
                                                            data,
                                                        )}
                                                        handleProductClick={handlePvModal}
                                                    />
                                                </>
                                            ) : (
                                                <>
                                                    <ListView
                                                        data={data}
                                                        favId={`searchProd_${index}`}
                                                        drawerHandler={toggleDrawer(
                                                            'right',
                                                            true,
                                                            data,
                                                        )}
                                                        handleProductClick={handlePvModal}
                                                    />
                                                </>
                                            )}
                                        </>
                                    ))}
                                </InfiniteScroll>
                            </div> */}
                        </div>

                        {/* PAGINATION - Show pagination controls */}
                        <div
                            className="d-flex justify-content-between align-items-center flex-wrap w-100 my-3 pagination-wrapper"
                            id="search_pagination"
                        >
                            <h6>
                                {'Showing'} {allProducts?.setDisp || 0} {'of'}{' '}
                                {allProducts?.totalRecords || 0}
                            </h6>
                            {props.pagination ? (
                                <Pagination
                                    count={Math.ceil(
                                        (allProducts?.totalRecords || 0) /
                                            formikSearch.values.limit,
                                    )}
                                    page={formikSearch.values.page || 1}
                                    onChange={onHandlePage}
                                    siblingCount={3}
                                    showFirstButton
                                    showLastButton
                                    boundaryCount={2}
                                />
                            ) : null}
                        </div>
                    </>
                ) : (
                    <NoRecordsFound />
                )}
            </div>
            {viewModel && (
                <Popup
                    open={viewModel}
                    handleClose={handleClose}
                    modalSize={true}
                    productID={selectedProduct && selectedProduct.id}
                    popRedirect={handleRedirect}
                >
                    {selectedProduct && (
                        <ProductView
                            data={selectedProduct.id}
                            pvModalSimilarItems={true}
                            isPopup={true}
                        />
                    )}
                </Popup>
            )}
        </>
    )
}
export default SearchComp
